<!--
 * @Description: 
 * @Author: dezhi
 * @Date: 2020-02-19 15:46:56
 * @LastEditTime: 2020-10-13 14:59:54
 * @LastEditors: zhaoshuai
 -->
<template>
  <header class="header flex sharing-h">
    <div class="wrapper flex sharing-h" :class="{bordernone:$route.path =='/login'}">
      <div class="flex sharing-h">
        <img class="logo" src="@/assets/images/logo.png" />
        <div class="logo-area">税务管理师CTM（初级）专业能力水平证书</div>
      </div>
      <div class="user-info" v-if="loginStatus&&$route.path!='/login'">
        {{userInfo.realName}}，您好！
        <a @click="logout">退出</a>
      </div>
    </div>
  </header>
</template>

<script>
// @ is an alias to /src

import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("account");
export default {
  name: "Header",
  components: {},
  data() {
    return{
      userInfo: {}
    }
  },
  computed: {
    ...mapState({
      loginStatus: state => state.loginStatus
    })
  },
  mounted() {
   
    let loginStatus = localStorage.getItem('loginStatus') == 'true'?true:false;
    this.userInfo = localStorage.getItem('apply_userInfo')?JSON.parse(localStorage.getItem('apply_userInfo')):"";
    this.$store.commit('account/setLoginStatus', loginStatus)

  },
  methods: {
    logout() {
      let me=this
     
      this.$confirm({
        title: '退出',
        okText:'确定',
        cancelText:'取消',
        content:() => <div style="color:#B01F21;">确认退出,已上传/填写将会保存?</div>,
        onOk() {
           me.$store.commit('account/logout')
           me.$router.replace('/')
        },
      
      });
    
    }
  }
};
</script>

<style>
.header {
  background: #fff;
  text-align: left;
}
.header > div {
  border-bottom: 1px solid #F9BE00;
}
.header>.bordernone {
  border:none
}
.logo-area {
  color: rgba(145, 38, 43, 1);
}
.user-info a {
  color: #b01f21;
}
.logo {
  width: 146px;
}
</style>